<template>
  <div class="row Wrap page-main-detail">
    <div class="container" style="margin-top:10px;width:1200px">
      <div class="row page-current">
        <img class="icon1" src="@/../static/images/news/icon-cur.png" />
        <span class="linkspan">
          <router-link to="/index" class="link">首页</router-link>/
          <a href="javaSript:void(0);" class="cur">参展指南</a>/
          <!-- <router-link to="/Business" class="link">商务部投促局</router-link>/ -->
          <a href="javaSript:void(0);" class="cur">{{$route.name}}</a></span>
      </div>
      <div class="headerBox">
        <header style="display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: space-around;">
          <div>
            <span class="headerTitle">数字展厅</span>
            <br>
            <span class="headerTitleEnglish">Digital showroom</span>
          </div>
           <div class="searchBox" style="float:right">
            <el-input
              placeholder="请输入展厅名称"
              prefix-icon="el-icon-search"
              v-model="searchData.name"
              style="border-radius:none;border: 1px solid #D0D1D6;
              width:392px;margin-right:30px"
              >
            </el-input>
            <button class="searchBtn" @click="search">搜索</button>
          </div>
           
        </header>
        <div style="width:260px">
          <switch_a v-model="searchData.type" :list='tabList' @change='search'></switch_a>
        </div>
        
      </div>
      <div class="wrap">
        <!-- src="http://b-dev.oss-accelerate.aliyuncs.com/image/article-cover/20200806154549493-7.jpg" -->
        
        <roomList :getDataFun='getAllList' :pageSize='16'  :searchForm='searchData' :rowNumber='4' liWidth="23%" margin="2.3%" ref="roomList_all"></roomList>
      </div>

    </div>
  </div>
</template>

<script>
import { Notification } from 'uiv'
import {list} from './api'
// import page from '@/view/CloudFair/components/page.vue'
import roomList from './roomList.vue'
import switch_a from './switch.vue'

export default {
  components: {
    // page
    roomList,
    switch_a
  },
  created(){
    // console.log(this.$route)
    // this.getData(this.searchData)
    
        
  },
  data() {
    return {
      // keyword:"",
      getAllList:list,
      params:null,
      searchData:{
        pageNum:1,
        total:0,
        pageSize:8,
        name:"",
        type:0
      },
      data:{},
      tabList:[
        {name:"中国大陆",value:0},
        {name:"其他地区",value:1},
      ]
     
    };
  },
  methods: {
    // changeTab(type)
    // {
    //   this.searchData.type=type
    //   this.search()
    // },
    //跳转到详情页
    goDetail(id){
      this.$router.push({
        name: 'InformationDetail',
        params:{
          id:id,
          name:'资讯详情'
        }
      })
    },
    search(){
      this.$refs.roomList_all.getData(this.searchData,1)
    },
    jumpPage(pageNo){
      // console.log(demo)
      this.searchData.pageNum=pageNo
      // this.getData()
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.col-sm-2,
.col-md-2 {
  width: 22%;
}
.col-sm-10,
.col-md-10 {
  width: 78%;
}
.page-left {
  margin-top: 2%;
}
.page-right {
  margin-top: 2%;
  min-height: 500px;
}
.container{
  padding: 10px;
}

span.headerTitle {
    width: 120px;
    height: 31px;
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #EA0E1E;
    line-height: 40px;
}
span.headerTitleEnglish {
    width: 222px;
    height: 14px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    line-height: 40px;
    // display: block;
}

button.searchBtn {
    width: 90px;
    height: 36px;
    background-color: #DC0006FF;
    /* width: 24px; */
    /* height: 13px; */
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    /* display: block; */
    border: none;
    margin: 10px 0;
}
.searchBox /deep/ .el-input__inner
{
  
  border: none ;
  font-family: Microsoft YaHei;
 
}
.searchBox /deep/ .el-input__inner
{
  
  border: none ;
  font-family: Microsoft YaHei;
  width: 390px;
height: 36px;
// border: 1px solid #D0D1D6;
border: none;
   border-radius: none;
}


.listBox
{
  font-size: 16px;
  font-family: Microsoft YaHei;

  // width: 1200px;
  // height: 196px;
  background: #FFFFFF;
  // box-shadow: 0px 3px 8px 1px rgba(0, 0, 0, 0.08);
  display: flex;
  // display: flex;
    justify-content: space-between;
    padding: 30px 20px 30px 24px;
    transition: padding-left 1s;
    flex-wrap: wrap;
         border-bottom: 1px solid #E7E7E7;
}

.go
  {
    display: none;
  }

.listBox:hover
{
  padding-left: 40px;
  transform: translateY(-10px);
  box-shadow: 0px 3px 8px 1px rgba(0, 0, 0, 0.08);
   .go
  {
    display: block;
  }
  
}
.listBox:hover .leftBox
{
  // color: black;
  margin-right: 10px;

}

.leftBox
{
  margin-right: 16px;
  transition: margin-right 1s;
}

.listBox:hover .title
{
  color: #EA0E1EFF ;
}


.rightBox
{
  width: 810px;
  display: flex;
    align-content: space-between;
    flex-direction: column;
    justify-content: space-between;
}
.title
{
  // height: 17px;
  font-size: 16px;
  font-weight: 600;
  color: #333333FF;
}
.content{
  height: 40px;
  color: #999;
}

.date
{
   color: #666;
}
.go
{
  float:right;
  color: #EA0E1E;
}





.page-main-detail{
  min-height: 500px;
}
.headerBox
{
    margin: 0 0 55px 0;
}
.headerBox>header
{
  margin: 0 0 45px 0;
}
@media (min-width: 320px) and (max-width: 767px) {
  .page-right {
    min-height: auto;
  }
  .col-xs-12 {
    width: 100%;
  }
}

</style>



// WEBPACK FOOTER //
// src/view/exhibitionHall/index.vue